
import React from "react";
import "./MoveOutCleaningService.css";

const MoveOutCleaningService = () => {
  return (
    <div className="move-out-cleaning-container">
      <h1>Leave a Lasting Clean Impression</h1>
      <p>
        Whether you’re handing over keys to a landlord or listing your property for sale,
        our Move Out Cleaning service helps ensure it’s in the best possible condition.
        We clean thoroughly so you can focus on your next move with confidence.
      </p>

      <h2>What’s Included:</h2>
      <ul>
        <li>Deep cleaning of kitchen and bathrooms</li>
        <li>Wipe down of walls, doors, and light fixtures</li>
        <li>Cleaning inside cabinets and closets</li>
        <li>Vacuuming and mopping all floors</li>
        <li>Trash removal and deodorizing</li>
      </ul>

      <h2>Why Choose Us for Move Out Cleaning?</h2>
      <ul>
        <li>🧼 <strong>Deposit Friendly Results</strong> – We help maximize your chances of getting your full deposit back.</li>
        <li>📦 <strong>Stress-Free Transitions</strong> – Focus on your new home while we handle the cleaning.</li>
        <li>🔑 <strong>Trusted by Realtors & Property Managers</strong> – We work with industry professionals for a flawless handover.</li>
        <li>🕒 <strong>Flexible Booking</strong> – Moving is hectic, we adapt to your timeline.</li>
        <li>🧡 <strong>Satisfaction Guaranteed</strong> – We don’t leave until your old space feels new again.</li>
      </ul>
    </div>
  );
};

export default MoveOutCleaningService;
